// extracted by mini-css-extract-plugin
export default {"collapse":"TimesheetCollapse_collapse__aJ96+","badge":"TimesheetCollapse_badge__s4pUm"};